module.exports = __webpack_public_path__ + "static/media/slezakova.c485273f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/slezakova.jpg
// module id = 184
// module chunks = 0